import { weightedPick } from '../util';
import { Tileset } from './Tileset';

/**
 * Post: 2x1 Rectangle, 2 Minis, Big Square
 */
// +--+--+-----+
// |  A  |     |
// +--+--+  D  +
// |B |C |     |
// +-----+-----+
export class PostRectMini2BigTileset extends Tileset {
	// The following functions are inherited from Tileset:
	// load(post) sets this.post and calls this.loadTileTypes
	// getUncompiledHtml() loads this.metaTypes and gets the html for all the tiles
	// getTileDimensions() gets the JSON string containing width and height based on the layout size

	/**
	 * Define tile layout: 2 tiles each sized 2x2, side by side
	 */
	constructor() {
		super();
		/**
		 * The name of this tileset
		 * @type {String}
		 */
		this.name = 'PostBigMini2Rect';
		/**
		 * The number of 1x1 meta tiles that this tileset uses
		 * @type {Number}
		 */
		this.numMetaTiles = 2;
		/**
		 * The size and position of each tile slot
		 * @type {Object[]}
		 */
		this.layout = [
			{ size: '2x1', style: 'left: 0; top: 0; width: 50%; height: 50%' }, // A
			{ size: '1x1', style: 'left: 0; top: 50%; width: 25%; height: 50%' }, // B
			{ size: '1x1', style: 'left: 25%; top: 50%; width: 25%; height: 50%' }, // C
			{ size: '2x2', style: 'left: 50%; top: 0; width: 50%; height: 100%' }, // D
		];
	}

	/**
	 * Load the tile types that will populate this.layout
	 */
	loadTileTypes() {
		if (this.post.masonry.hasInsight) {
			/**
			 * The names of the tile types to use
			 * @type {String[]}
			 */
			this.tileTypes = weightedPick([
				//                   A          B       C       D
				{ weight: 30, value: ['insight', 'meta', 'meta', 'image'] },
				{ weight: 50, value: ['image', 'meta', 'meta', 'insight'] },
				{ weight: 10, value: ['headline', 'meta', 'meta', 'insightOverImage'] },
				{ weight: 10, value: ['insight', 'meta', 'meta', 'headlineOverImage'] },
			]);
		} else {
			this.tileTypes = weightedPick([
				//                   A        B       C       D
				{ weight: 30, value: ['image', 'meta', 'meta', 'headline'] },
				{ weight: 70, value: ['headline', 'meta', 'meta', 'image'] },
			]);
		}
	}
}
